var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import Select from '../ReusableSelect';
import { SelectContainer } from './styles';
/** Position of the options while the select is in a modal can be problematic
 * this implementation ensures that the options follow the Select */
var SelectForModal = function (props) {
    var _a = useState(null), modalRef = _a[0], setModalRef = _a[1];
    return (_jsx(SelectContainer, __assign({ ref: function (ref) { return setModalRef(ref); }, margined: props.margined }, { children: modalRef && _jsx(Select, __assign({}, props, { menuPortalTarget: modalRef })) })));
};
export default SelectForModal;
